// extracted by mini-css-extract-plugin
module.exports = {"modalBackdrop":"ModalConfirmar_modalBackdrop__8RdNU"};